/* eslint eol-last: ["error", "never"] */
export default {
    loading: false,
    auditlist: true,
    viewaudit: false,
    audit: [],
}